const CC_RX = /(custom|costum) comments|commentaires personnalis/i;

// Single source of truth: a service is a Custom Comments service when its
// name / English name / display name matches the pattern (incl. the "costum" typo).
export function detectCustomComments(service) {
  if (!service) return false;
  const blob = `${service.name || ""} ${service.name_en || ""} ${service.display_name || ""}`;
  return CC_RX.test(blob);
}
